export { default } from './SliderComponent'
